import React from 'react';

import { SortingInput, SortingContainer, SortingWrapper, SortingIcon } from './styles';

export default function Sorting({ value, descendingOrder, options = [], onChange }) {
  return (
    <SortingWrapper>
      <SortingContainer>
        <SortingInput
          value={value}
          onChange={(e) => {
            onChange({
              value: e.target.value,
              descendingOrder,
            });
          }}
        >
          {options.map((opt, index) => (
            <option key={index} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </SortingInput>
      </SortingContainer>
      <SortingIcon
        descendingOrder={descendingOrder}
        onClick={() => {
          onChange({
            value,
            descendingOrder: !descendingOrder,
          });
        }}
      />
    </SortingWrapper>
  );
}
